import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { BridgePage } from './components/bridge/BridgePage';
import { PortfolioPage } from './components/portfolio/PortfolioPage';
import { ControlPage } from './components/control/ControlPage';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { WagmiConfig } from 'wagmi';
import { wagmiConfig, initWeb3Modal } from './config/web3';

// Initialize Web3Modal
initWeb3Modal();

function App() {
  return (
    <WagmiConfig config={wagmiConfig}>
      <Router>
        <div className="app-container">
          <Layout>
            <Routes>
              <Route path="/" element={<BridgePage />} />
              <Route path="/portfolio" element={<PortfolioPage />} />
              <Route path="/control" element={<ControlPage />} />
            </Routes>
          </Layout>
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="dark"
          />
        </div>
      </Router>
    </WagmiConfig>
  );
}

export default App;
